'use client';

import { useEffect, useState } from 'react';
import { cn } from '@/app/utils';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => {
      const hero = document.querySelector('[data-blog-hero]');
      const breadcrumbs = document.querySelector('[data-blog-breadcrumbs]');
      const offset = breadcrumbs ? breadcrumbs.getBoundingClientRect().bottom : 0;
      setVisible(hero ? hero.getBoundingClientRect().bottom <= offset : false);
    };
    check();
    window.addEventListener('scroll', check, { passive: true });
    return () => window.removeEventListener('scroll', check);
  }, []);

  return (
    <div
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={cn(
        'fade-in fixed right-8 bottom-8 z-50 animate-in cursor-pointer duration-300 md:hidden',
        visible ? 'opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      <div className="relative flex h-16 w-16 flex-col items-center justify-center overflow-hidden rounded-full bg-gradient-to-l from-[#93d7ff] to-[#dfddff] shadow-[0px_4px_24px_0px_rgba(0,0,0,0.24)] transition-transform hover:scale-105">
        <div className="absolute top-[10px] left-[21px] h-[22px] w-[22px] overflow-hidden">
          <div data-svg-wrapper="" className="relative">
            <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M23.75 18.75L15 11.25L6.25 18.75"
                stroke="black"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className="absolute top-[32px] left-[18px] font-semibold text-black text-sm leading-relaxed">Top</div>
      </div>
    </div>
  );
}
